<template>
  <div class="wrapper">
    <RadioButton
      @radiochange="onRadioChange"
      :selected="selected"
    />
    <div v-if="selected === 'taxDisk'">
      <TaxDisk
        :deviceList="deviceList"
        :currentCompany="currentCompany"
        :changeDevice="changeDevice"
        :blankInvoiceList="blankInvoiceList"
        :syncBlankInvoiceAsync="syncBlankInvoiceAsync"
      />
    </div>
    <div v-if="selected === 'sellerInfo'">
      <SellerInfo
        :currentCompany="currentCompany"
      />
    </div>
    <div v-if="selected === 'clear'">
      <Clear
        :currentCompany="currentCompany"
      />
    </div>
  </div>
</template>

<script>
import RadioButton from './RadioButton/index.vue'
import TaxDisk from './TaxDisk/index.vue'
import SellerInfo from './SellerInfo/index.vue'
import Clear from './Clear/index.vue'
import { Toast, Notify } from 'vant'
import { accountRequest, invoiceRequest } from '@services'
import { isEmpty, localStorage, sessionStorage } from '@utils/basicUtil'
export default {
  components: {
    RadioButton,
    TaxDisk,
    SellerInfo,
    Clear,
    [Toast.name]: Toast,
    [Notify.name]: Notify
  },
  props: {},
  data () {
    return {
      dayShow: true,
      monthShow: false,
      selected: 'taxDisk',
      deviceList: [{}],
      currentCompany: {},
      blankInvoiceList: []
    }
  },
  computed: {},
  watch: {},
  created () {},
  async mounted () {
    await this.getCurrentCompany()
    await this.getBlankList()
  },
  activated () {},
  updated () {},
  methods: {
    handleChangeDayCss () {
      this.dayShow = true
      this.monthShow = false
    },
    handleChangeMonthCss () {
      this.dayShow = false
      this.monthShow = true
    },
    onRadioChange (item) {
      console.log(item)
      this.selected = item.value
    },
    async getCurrentCompany () {
      const postData = {
        size: 9999
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        if (!data.result) {
          return
        }
        const {
          currentCompany
        } = data.result
        this.currentCompany = currentCompany
        this.deviceList = currentCompany.deviceList
        const currentCompanyData = await accountRequest.company.getCompanyDetail({}, { id: currentCompany.id })
        if (currentCompanyData.success) {
          if (!currentCompanyData.result || !currentCompanyData.result.companyInfoResponse) {
            return
          }
          console.log(currentCompanyData)
        } else {
          Notify({ type: 'danger', message: currentCompanyData.message })
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async syncBlankInvoiceAsync () {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '开始同步！'
      })
      const result = await invoiceRequest.blank.syncBlankInvoiceAsync({ invoiceType: 0 })
      if (result.success) {
        this.getBlankList()
      }
      Toast.clear()
    },
    async getBlankList () {
      const invoiceType = this.currentCompany.companyInfoResponse.invoiceType.split(',') || []
      const deviceType = this.currentCompany.currentDevice.deviceType
      const query = {
        current: 1,
        size: 25,
        invoiceType: '1,2,3,4,5',
        asc: undefined,
        desc: 'gmt_create'
      }
      const result = await invoiceRequest.blank.getBlankList(query)
      if (result.success) {
        if (result.result.records) {
          if (result.result.records.length === 0) {
            if (query.invoiceType) { // 有查询条件，不处理
            } else if (isEmpty(deviceType)) { // 没有设置税盘信息，不处理
            } else {
              result.result.records = invoiceType.map((v, i) => ({
                id: i,
                key: i,
                order: i + 1,
                receiveTime: '--',
                invoiceType: v,
                invoiceCode: '--',
                invoiceNo: '--',
                invoiceStartNum: '--',
                invoiceEndNum: '--',
                invoiceCount: '--',
                quantity: 0,
                issuedInvoiceCount: '--',
                invoiceToolType: deviceType
              }))
            }
          } else {
            const recordInvoiceType = []
            result.result.records.forEach((v, i) => {
              v.key = v.id
              v.order = i + 1
              recordInvoiceType.push(v.invoiceType)
            })
            if (!query.invoiceType) {
              invoiceType.forEach(v => {
                if (recordInvoiceType.includes(Number(v)) === false) {
                  result.result.records.push({
                    id: result.result.records.length + 1,
                    order: result.result.records.length + 1,
                    receiveTime: '--',
                    invoiceType: v,
                    invoiceCode: '--',
                    invoiceNo: '--',
                    invoiceStartNum: '--',
                    invoiceEndNum: '--',
                    invoiceCount: '--',
                    quantity: 0,
                    issuedInvoiceCount: '--',
                    invoiceToolType: deviceType
                  })
                }
              })
            }
          }
        } else {
          result.result.records = invoiceType.map((v, i) => ({
            id: i,
            order: i + 1,
            receiveTime: '--',
            invoiceType: v,
            invoiceCode: '--',
            invoiceNo: '--',
            invoiceStartNum: '--',
            invoiceEndNum: '--',
            invoiceCount: '--',
            quantity: 0,
            issuedInvoiceCount: '--',
            invoiceToolType: deviceType
          }))
        }
        console.log(result.result.records)
        this.blankInvoiceList = result.result.records
      }
    },
    async changeDevice (deviceId) {
      const result = await invoiceRequest.blank.changeDevice({ deviceId })
      if (result.success) {
        localStorage.set('X-C-Token', result.result)
        sessionStorage.set('X-C-Token', result.result)
        localStorage.set('deviceId', deviceId)
        window.history.go(0)
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
